<div class="icon icon-red">
  <i class="fa-regular fa-calendar-xmark"></i>
</div>
<span class="font-medium-title-large">Seminar absagen</span>
<span class="font-regular-body-large">
  Beschreibe, warum du das Seminar absagen möchtest.
</span>
<div class="input-simple align-self-stretch">
  <div class="input-label-wrapper">
    <label for="description" class="input-label"> Beschreibung* </label>
    <div class="input-label-hint">
      {{ reason?.length }}
      /
      {{ 1200 }}
    </div>
  </div>
  <textarea
    id="description"
    name="description"
    class="input-textarea"
    rows="4"
    [(ngModel)]="reason"
    placeholder="Beschreibung"
    required></textarea>
</div>
@if (errorMessage) {
  <div class="inwi-text-error font-regular-label-large">{{ errorMessage }}</div>
}
<div class="flex-r gap-16 justify-center padding-top-16">
  <button
    type="button"
    class="inwi-text-button-large-secondary"
    (click)="closeDialog(false)">
    <div class="button-content">
      <div class="button-text">Abbrechen</div>
    </div>
  </button>
  <button
    type="button"
    (click)="closeDialog(true)"
    class="inwi-text-button-large-primary">
    <div class="button-content">
      <div class="button-text">Absagen</div>
    </div>
  </button>
</div>
